export interface PanelButtonProps {
  props: { label: string; action_id?: string };
}

/** Display-only button (v1). Interactivity is post-v1. */
export function PanelButton({ props }: PanelButtonProps) {
  return (
    <button
      type="button"
      className="px-sd-3 py-sd-1 text-sd-sm font-medium bg-sd-surface border border-sd-border/40 rounded-sd-md text-sd-text hover:bg-sd-surface-elevated transition-colors duration-150 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sd-primary/50"
      disabled
      aria-disabled="true"
    >
      {props.label}
    </button>
  );
}
